import { action } from "mobx";
import agent from "../shared/agent";
import authStore from "./auth";
import mapaStore from "./mapa";

class LoginStore {
  inProgress = false;

  error = "";

  login = "";

  senha = "";

  setError(error) {
    this.error = error;
  }

  setLogin(login) {
    this.login = login;
  }

  setSenha(senha) {
    this.senha = senha;
  }

  reset() {
    this.login = "";
    this.senha = "";
  }

  fazerLogin() {
    this.inProgress = true;
    return agent.Auth.login(this.login, this.senha)
      .then((res) => {
        if (res.CodigoRetorno === 1) {
          this.setError("");
          authStore.setSessaoGuidId(res.SessaoGuidId);
          authStore.setRefreshTokenSessao(res.RefreshTokenSessao);
          authStore.setUsuario(res.Usuario);
          authStore.setEmpresa(res.Empresa);
          mapaStore.setOrigem(res.Empresa.Latitude, res.Empresa.Longitude)
          mapaStore.setModoDistribuicao(res.Empresa.ModoDistribuicao)
        } else {
          this.setError(res.Mensagem);
          throw res;
        }
      })
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }
}

export default new LoginStore();
